import { useState } from "react";
import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
} from "../components/ui/dialog";
import { Magnetic } from "./Motion";
import { track } from "../utils/track";
import { STANDARD_PAYMENT_URL, PRICE } from "../config/brand";

export const isUrlConfigured = (url) => url && !url.includes("INSERT_");

export const usePurchase = (url = STANDARD_PAYMENT_URL) => {
  const [open, setOpen] = useState(false);
  const purchase = (event) => {
    if (event) track(event);
    window.dispatchEvent(new Event("bp-purchase-intent"));
    if (isUrlConfigured(url)) {
      window.location.href = url;
    } else {
      setOpen(true);
    }
  };
  const dialog = (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogContent
        className="max-w-md rounded-3xl border-mauve/40 bg-warmwhite"
        data-testid="checkout-notice-dialog"
      >
        <DialogHeader>
          <DialogTitle className="font-serif text-2xl text-plum">
            Checkout opens soon
          </DialogTitle>
          <DialogDescription className="pt-2 text-base leading-relaxed text-plumcharcoal/70">
            The BloomParentify System checkout link is being connected.
            Everything on this page reflects exactly what you'll receive for{" "}
            {PRICE} — you'll know precisely what's included before you
            purchase.
          </DialogDescription>
        </DialogHeader>
        <button
          onClick={() => setOpen(false)}
          data-testid="checkout-notice-close"
          className="mt-2 inline-flex justify-center rounded-xl bg-plum px-6 py-3 text-sm font-semibold text-ivory transition-colors hover:bg-plum/90 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-plum"
        >
          Got it
        </button>
      </DialogContent>
    </Dialog>
  );
  return { purchase, dialog };
};

export const PurchaseButton = ({
  event,
  testId,
  className = "",
  arrow = true,
  children,
}) => {
  const { purchase, dialog } = usePurchase();
  return (
    <>
      <Magnetic strength={3}>
        <motion.button
          type="button"
          onClick={() => purchase(event)}
          data-testid={testId}
          data-analytics-event={event}
          whileHover={{ scale: 1.02, y: -2 }}
          whileTap={{ scale: 0.97 }}
          transition={{ duration: 0.18, ease: "easeOut" }}
          className={
            className ||
            "group inline-flex items-center justify-center gap-2 rounded-xl bg-rose px-7 py-4 text-sm font-bold uppercase tracking-[0.08em] text-warmwhite shadow-[0_10px_30px_rgba(201,130,150,0.4)] transition-[background-color,box-shadow] duration-200 hover:bg-[#b96f84] hover:shadow-[0_16px_40px_rgba(201,130,150,0.5)] focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-rose"
          }
        >
          {children}
          {arrow && (
            <ArrowRight
              size={16}
              strokeWidth={2}
              className="transition-transform duration-200 group-hover:translate-x-1"
            />
          )}
        </motion.button>
      </Magnetic>
      {dialog}
    </>
  );
};
